import { Injectable } from "@angular/core";
import { User } from "firebase/auth";
import { BehaviorSubject } from "rxjs";
import { SubscriptionPreferences } from "src/class/classes";

@Injectable({
    providedIn: 'root'
})
export class GlobalsService {

    userAccountSubject = new BehaviorSubject(undefined)
    authSubject = new BehaviorSubject<undefined | User>(undefined)

    raisingDealsFlat = undefined

}